import { css, type Theme } from "@emotion/react";
import { borders } from "aviary-tokens";

import { animations } from "@styles";

const isSelected = (theme: Theme) => css`
  background: ${theme.primary.backgroundBase};
`;

export const dotButton = {
  base: (theme: Theme) => css`
    width: 0.5rem;
    height: 0.5rem;
    background: ${theme.primary.backgroundMutedHover};
    border-radius: ${borders.radiusCircle};
    padding: 0;
    ${animations.transition()};

    &:hover {
      background: ${theme.primary.backgroundMutedActive};
    }
  `,
  selected: (theme: Theme) => css`
    ${isSelected(theme)};
  `,
};
